export const QUOTATION_ROUTING = [
    {
        path: '/quotation',
        name: 'quotation',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Báo giá chính ngạch', pathName: 'quotation', icon: 'fa fa-file-text-o' },
            ]
        },
        component: () => import('./Quotation.vue'),
        redirect: { name: 'quotation-index' },
        children: [
            {
                path: '/bao-gia.html',
                name: 'quotation-index',
                meta: {
                    breadcrumb: [
                        { name: 'Danh sách báo giá', pathName: 'quotation-index', icon: 'fa fa-file-text-o' },
                    ]
                },
                component: () => import('./list/List.vue')
            },
            {
                path: '/bao-gia/tao-don-ky-gui.html',
                name: 'quotation-create-consignment',
                meta: {
                    breadcrumb: [
                        { name: 'Tạo đơn ký gửi chính ngạch', pathName: 'quotation-create-consignment', icon: 'fa fa-plus' },
                    ]
                },
                component: () => import('./create/CreateConsignment.vue')
            },
            {
                path: '/bao-gia/khieu-nai.html',
                name: 'quotation-complain-list',
                meta: {
                    breadcrumb: [
                        { name: 'Khiếu nại báo giá', pathName: 'quotation-complain-list', icon: 'fa fa-exclamation-triangle' },
                    ]
                },
                component: () => import('./complain/ListQuotationComplaints.vue')
            },
            {
                path: '/bao-gia/:id',
                name: 'quotation-detail',
                meta: {
                    breadcrumb: [
                        { name: 'Chi tiết báo giá', pathName: 'quotation-detail', icon: 'fa fa-file-text-o' },
                    ]
                },
                component: () => import('./detail/DetailQuotation.vue')
            },
            {
                path: '/khieu-nai-bao-gia/:orderId/:orderType',
                name: 'quotation-complain',
                meta: {
                    breadcrumb: [
                        { name: 'Khiếu nại báo giá', pathName: 'quotation-complain', icon: 'fa fa-exclamation-triangle' },
                    ]
                },
                component: () => import('../order/components/complain-order/ComplainOrder.vue')
            },
            {
                path: '/khieu-nai-bao-gia/:orderId/:complainId/:orderType',
                name: 'detail-quotation-complain',
                meta: {
                    breadcrumb: [
                        { name: 'Chi tiết khiếu nại báo giá', pathName: 'detail-quotation-complain', icon: 'fa fa-exclamation-triangle' },
                    ]
                },
                component: () => import('../order/components/complain-order/ComplainOrder.vue')
            }
        ]
    }
];